import "./CSS/App.css";
import "./CSS/Desktop.css";
import "./CSS/Mobile.css";

import { useState, useEffect } from "react";
import IsMobile from "./Components/Hooks/IsMobile";
import Mobile from "./Components/Layouts/Mobile";
import Desktop from "./Components/Layouts/Desktop";
import { Projects } from "./ProjectData";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  const isMobile = IsMobile(); // returns true or false based on screen width
  const [currentProject, setCurrentProject] = useState("Buzzkill");
  const [currentIndex, setCurrentIndex] = useState(0);

  // Single source of truth: derive the active project's images from Projects,
  // matching whatever the renderer in Desktop.js / Mobile.js actually displays.
  const currentImages =
    Projects.find((p) => p.key === currentProject)?.images ?? [];

  useEffect(() => {
    // Reset index when project changes
    setCurrentIndex(0);
  }, [currentProject]);

  const nextImage = () => {
    if (currentImages.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex + 1) % currentImages.length);
  };

  const prevImage = () => {
    if (currentImages.length === 0) return;
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + currentImages.length) % currentImages.length
    );
  };

  const changeProject = (project) => setCurrentProject(project);
  return (
    <Router>
      {isMobile ? (
        <Mobile
          currentProject={currentProject}
          setCurrentProject={setCurrentProject}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          nextImage={nextImage}
          prevImage={prevImage}
          changeProject={changeProject}
        />
      ) : (
        <Desktop
          currentProject={currentProject}
          setCurrentProject={setCurrentProject}
          currentIndex={currentIndex}
          nextImage={nextImage}
          prevImage={prevImage}
          changeProject={changeProject}
        />
      )}
    </Router>
  );
}

export default App;
